// extracted by mini-css-extract-plugin
export default {"donut":"style_donut__NNgat","svg":"style_svg__SeuEy","center":"style_center__-UqAY"};